import { CSSProperties, useEffect, useRef, useState } from "react";
import { FloatButton, Tag } from "antd";
import { Webchat, Configuration } from "@botpress/webchat";
import icon from "~/assets/logo/float-button.jpg";
import "./float-button.less";
import { useScreenSize } from "~/hooks/useScreenSize";

const clientId = "6f55d317-acc8-419d-a297-ec147bb3d1c1";

const configuration: Configuration = {
  color: "#FBAD16",
  botDescription: "Trợ lý AI của Apetechs",
  composerPlaceholder: "Nhập nội dung cần hỗ trợ",
  botName: "APE AI",
  botAvatar: icon,
  fabImage: icon,
  website: {
    title: "https://apetechs.com",
    link: "https://apetechs.com",
  },
  email: {
    title: "info@aptechs.com",
    link: "info@aptechs.com",
  },
  phone: {
    title: "0987183484",
    link: "0987183484",
  },
  termsOfService: {
    title: "Terms of service",
    link: "https://apetechs.com/chinh-sach-bao-mat/",
  },
  privacyPolicy: {
    title: "Privacy policy",
    link: "https://apetechs.com/chinh-sach-bao-mat/",
  },
  variant: "solid",
  headerVariant: "glass",
  feedbackEnabled: true,
  allowFileUpload: false,
};

const ChatBotAI = () => {
  const [isWebchatOpen, setIsWebchatOpen] = useState(false);
  const chatRef = useRef<HTMLDivElement | null>(null);
  const { isMobile } = useScreenSize();

  const toggleWebchat = () => {
    setIsWebchatOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (chatRef.current && !chatRef.current.contains(event.target as Node)) {
        setIsWebchatOpen(false);
      }
    };

    if (isWebchatOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isWebchatOpen]);

  const floatButtonStyle: CSSProperties = isMobile
    ? {
      position: "fixed",
      bottom: 20,
      right: 20,
      zIndex: 999,
      display: "flex",
      alignItems: "center",
      gap: 8,
    }
    : {
      position: "fixed",
      bottom: 55,
      right: 75,
      zIndex: 999,
      display: "flex",
      alignItems: "center",
      gap: 8,
    };

  const chatboxStyle: CSSProperties = isMobile
    ? {
      position: "fixed",
      bottom: 120,
      right: 10,
      left: 10,
      height: "calc(100vh - 200px)",
      maxHeight: 500,
      zIndex: 1000,
      border: "1px solid #ddd",
      borderRadius: 8,
      overflow: "hidden",
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    }
    : {
      position: "fixed",
      bottom: 120,
      right: 20,
      width: 400,
      height: 600,
      zIndex: 1000,
      border: "1px solid #ddd",
      borderRadius: 8,
      overflow: "hidden",
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    };

  return (
    <div>
      <div style={floatButtonStyle}>
        {!isWebchatOpen && !isMobile && (
          <Tag
            className="custom-tag-chat"
            style={{
              fontSize: 14,
              fontWeight: 600,
              padding: "8px 16px",
              borderRadius: 20,
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.1) 40%, rgba(255,255,255,0) 100%), linear-gradient(135deg, #ffd38b, #FFC107, #f9ad36, #f98436)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              border: "none",
            }}
          >
            Hỏi đáp cùng APE AI
          </Tag>
        )}

        <FloatButton
          icon={
            <img
              src={icon}
              alt="APE AI"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          }
          type="primary"
          className="custom-float-btn"
          onClick={toggleWebchat}
        />
      </div>

      {/* Hộp chat */}
      {isWebchatOpen && (
        <div ref={chatRef} style={chatboxStyle}>
          <Webchat clientId={clientId} configuration={configuration} />
        </div>
      )}
    </div>
  );
};

export default ChatBotAI;
